<p-toast />

<section class="p-6 flex-table-page" data-testid="package-operation-page">
  <div class="mb-6 flex justify-between items-center flex-table-header">
    <h2 class="text-2xl font-semibold text-gray-800">
      {{ 'package_operation.title' | translate }}
    </h2>
  </div>

  <app-search-form
    data-testid="package-operation-search-form"
    [searchFormat]="searchConfig"
    (formSearch)="onSearch($event)"
    (formReset)="onReset()"
  >
    <div slot="actions" class="flex gap-2">
      <app-button
        [testId]="'package-operation-column-config-btn'"
        type="success"
        [outlined]="true"
        icon="view_column"
        (emitOnClick)="onColumnConfigClick($event)"
      ></app-button>
    </div>
  </app-search-form>

  <div class="table-section flex-table-section">
    <advanced-data-table
      data-testid="package-operation-inventory-table"
      #inventoryTable
      [dataSource]="inventoryItems()"
      [defaultColumns]="inventoryColumns"
      [loading]="inventoryLoading()"
      [rows]="inventoryPage().size"
      [first]="(inventoryPage().page - 1) * inventoryPage().size"
      [totalRecords]="inventoryTotalRecords()"
      [showInternalColumnConfigButton]="false"
      scrollHeight="flex"
      class="w-full"
      (pageChange)="onInventoryPageChange($event)"
    >
      <ng-template #customTemplate let-value let-column="column">
        @if (column.prop === 'fulfillmentMode') {
          <span>{{ fulfillmentModeLabel(value) | translate }}</span>
        } @else if (column.prop === 'availableQty') {
          <span>{{ value | number }}</span>
        } @else if (column.prop === 'lastUpdateDate') {
          <span>{{ value ? (value | date: 'dd/MM/yyyy HH:mm') : '-' }}</span>
        } @else {
          <span [title]="value">{{ value || '-' }}</span>
        }
      </ng-template>

      <ng-template #actionsTemplate let-record>
        <div class="inline-flex items-center gap-2 whitespace-nowrap">
          @if (canPack()) {
            <app-button
              [testId]="'package-operation-pack-' + record.skuCode"
              [label]="'package_operation.actions.pack' | translate"
              type="action"
              class="action-pack"
              (emitOnClick)="openOperation('PACK', record)"
            ></app-button>
          }
          @if (canUnpack()) {
            <app-button
              [testId]="'package-operation-unpack-' + record.skuCode"
              [label]="'package_operation.actions.unpack' | translate"
              type="action"
              class="action-unpack"
              (emitOnClick)="openOperation('UNPACK', record)"
            ></app-button>
          }
          @if (canViewHistory()) {
            <app-button
              [testId]="'package-operation-history-' + record.skuCode"
              [label]="'package_operation.actions.view_history' | translate"
              type="action"
              class="action-view"
              (emitOnClick)="openHistory(record)"
            ></app-button>
          }
        </div>
      </ng-template>
    </advanced-data-table>
  </div>
</section>

<app-package-operation-history-drawer
  [visible]="historyVisible()"
  [packageSku]="selectedPackage()"
  [historyItems]="historyItems()"
  [loading]="historyLoading()"
  (visibleChange)="historyVisible.set($event)"
></app-package-operation-history-drawer>

<app-package-operation-form-dialog
  [visible]="operationVisible()"
  [operationType]="operationType()"
  [packageSku]="operationPackage()"
  [operationForm]="operationForm"
  [warehouseOptions]="operationWarehouseOptions()"
  [sourcePacks]="sourcePacks()"
  [sourcePacksLoading]="sourcePacksLoading()"
  [previewItems]="operationPreviewItems()"
  [stockEnough]="operationStockEnough()"
  [validationMessage]="operationValidationMessage()"
  [stockChecking]="operationStockChecking()"
  [submitting]="operationSubmitting()"
  (visibleChange)="operationVisible.set($event)"
  (warehouseChange)="onOperationWarehouseChange()"
  (quantityChange)="onOperationQuantityChange()"
  (sourcePackChange)="onSourcePackChange()"
  (submitOperation)="submitOperation()"
></app-package-operation-form-dialog>
